import { z } from "zod";

export const VISIBILITY_LEVELS = ["exact", "city", "country", "hidden"] as const;
export const visibilityLevelSchema = z.enum(VISIBILITY_LEVELS);

export const ENTRY_TYPES = ["vacation", "timeoff", "medical", "trip", "nomadic"] as const;
export const entryTypeSchema = z.enum(ENTRY_TYPES);

/** exact > city > country > hidden — higher index = more generous. */
const RANK: Record<(typeof VISIBILITY_LEVELS)[number], number> = {
  hidden: 0,
  country: 1,
  city: 2,
  exact: 3,
};

export type VisibilityLevel = (typeof VISIBILITY_LEVELS)[number];

/** The most generous of two levels (used when a viewer is in several circles). */
export function maxLevel(a: VisibilityLevel, b: VisibilityLevel): VisibilityLevel {
  return RANK[a] >= RANK[b] ? a : b;
}

/** The least generous of two levels (used to compose an org ceiling — never a floor). */
export function minLevel(a: VisibilityLevel, b: VisibilityLevel): VisibilityLevel {
  return RANK[a] <= RANK[b] ? a : b;
}

export function levelAtLeast(level: VisibilityLevel, threshold: VisibilityLevel): boolean {
  return RANK[level] >= RANK[threshold];
}
